import { gql } from '@apollo/client';

export const ALL_MYFORMS = gql`
  query AllMyForms($input: MyFormsInput!) {
    forms: userMyForms(input: $input) {
      createdAt
      updatedAt
      id
      name
      type
      monitoringForm {
        id
        name
        published
        programme {
          id
          name
          workspaces {
            id
            name
          }
        }
        intervention {
          id
          name
          programme {
            id
            name
            workspaces {
              id
              name
            }
          }
        }
        usersWithCaptureRoleCount
        usersWithApproverRoleCount
        submissionsCount
      }
      workspaceForm {
        id
        name
        workspace {
          id
          name
        }
        published
        respondentsCount
        usersWithCaptureRoleCount
        usersWithApproverRoleCount
        submissionsCount
      }
    }
  }
`;
